var moduleMap = {
	"./Pages": () => {
		return Promise.all([__webpack_require__.e(4300), __webpack_require__.e(2698), __webpack_require__.e(3906), __webpack_require__.e(561), __webpack_require__.e(1715), __webpack_require__.e(1442), __webpack_require__.e(6029), __webpack_require__.e(5989), __webpack_require__.e(735), __webpack_require__.e(6864), __webpack_require__.e(660), __webpack_require__.e(1536), __webpack_require__.e(9624), __webpack_require__.e(484), __webpack_require__.e(7850), __webpack_require__.e(2337), __webpack_require__.e(5717), __webpack_require__.e(9206), __webpack_require__.e(7578), __webpack_require__.e(2176), __webpack_require__.e(7386)]).then(() => (() => ((__webpack_require__(13163)))));
	},
	"./Reducers": () => {
		return Promise.all([__webpack_require__.e(5717), __webpack_require__.e(7971), __webpack_require__.e(8363)]).then(() => (() => ((__webpack_require__(8363)))));
	},
	"./Router": () => {
		return Promise.all([__webpack_require__.e(4300), __webpack_require__.e(2698), __webpack_require__.e(3906), __webpack_require__.e(561), __webpack_require__.e(1715), __webpack_require__.e(1442), __webpack_require__.e(6029), __webpack_require__.e(5989), __webpack_require__.e(735), __webpack_require__.e(6864), __webpack_require__.e(660), __webpack_require__.e(1536), __webpack_require__.e(9624), __webpack_require__.e(484), __webpack_require__.e(7850), __webpack_require__.e(2337), __webpack_require__.e(5717), __webpack_require__.e(9206), __webpack_require__.e(7578), __webpack_require__.e(2176), __webpack_require__.e(1644)]).then(() => (() => ((__webpack_require__(34287)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});